export default __webpack_public_path__ + "static/media/filtersButton.1faa24a6.svg";